<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="child">
<h1>Child</h1>
<p>Child.</p>
<p style="text-indent:0em;">You are what you see: Open your eyes and see what you are.</p>
<p style="text-indent:0em;">You are what you hear: Listen to your inner voice.</p>
<p style="text-indent:0em;">You are what you taste: Savour the moment.</p>
<p style="text-indent:0em;">You are what you smell: A rare perfume.</p>
<p style="text-indent:0em;">You are what you touch: Touch all with care.</p><br/>
<p style="text-indent:0em;">Child.</p>
<p style="text-indent:0em;">What is the greater ignorance: to know or not to know?</p>
<p style="text-indent:0em;">What is the greater crime: to deceive others or to deceive yourself?</p><br/>
<p style="text-indent:0em;">Child.</p>
<p style="text-indent:0em;">What is the greater trial: to learn to love through pain, or the pain of love?</p>
<p style="text-indent:0em;">What is the greater joy: to be served or to serve?</p>
<p style="text-indent:0em;">Which is the easier: to apologise for one’s wrongs or to be the bearer of a forgiving heart?</p><br/>
<p style="text-indent:0em;">Child.</p>
<p style="text-indent:0em;">You are as you speak: Speak so as to be heard.</p>
<p style="text-indent:0em;">You are as you breathe: Breathe deeply of life.</p>
<p style="text-indent:0em;">You are as you move: Move with grace.</p>
<p style="text-indent:0em;">You are as others perceive you: Bear yourself with humble pride.</p>
<p style="text-indent:0em;">You are as you create: Be as you are created.</p><br/>
<p style="text-indent:0em;">Child.</p>
<p style="text-indent:0em;">You are as you dream.</p>
<p style="text-indent:0em;">(And if this is so, you may ponder whereupon dreams come: What influence creates, what brief encounters set one on one’s path? What is it that catches the eyecatches at the heartthat others do not see?)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?3cdf8308